<template xmlns:el-col="http://www.w3.org/1999/html">
  <div style="height: 100%">
    <header-div></header-div>
    <div>
      <router-view :key="key"/>
    </div>
    <footer-div></footer-div>
  </div>
</template>

<script>
import footerDiv from './components/footer'
import headerDiv from './components/header'
export default {
  name: 'Dashboard',
  components: { footerDiv, headerDiv },
  data () {
    return {
      tabPosition: 'top',
      screenWidth: document.body.clientWidth,
      activeIndex: '1'
    }
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  created () {
    // let data = { userId: 1, token: '91c03618-ff5f-4325-9c89-309928cd1eca' }
    // this.$store.dispatch('product/productList', data)
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      // console.log(key, keyPath)
      this.$router.push({ path: '/' + key })
    }
  }
}
</script>

<style scoped>
</style>
